import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-banner-advertisement',
  templateUrl: './banner-advertisement.component.html',
  styleUrls: ['./banner-advertisement.component.scss'],
})
export class BannerAdvertisementComponent {
  @Input() show = true;
  @Output() dismiss = new EventEmitter();
  @Output() buttonClick = new EventEmitter();

  constructor(public translate: TranslateService) {}

  openLink(): void {
    this.buttonClick.emit();
  }

  dismissLink(): void {
    this.dismiss.emit();
  }

  closeLink(): void {
    this.show = false;
  }
}
